/* 48 Hour Digital homepage behaviour: scroll reveal, Klaviyo guide signup, "Pick three" dial.
   Every section includes this file; the guard below makes it run once per page. */
(function () {
  if (window.hd48Loaded) return;
  window.hd48Loaded = true;
  document.documentElement.classList.add('hd48-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* Scroll reveal */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' })
    : null;

  function initReveal(root) {
    root.querySelectorAll('.hd48 .reveal:not(.in)').forEach(function (el) {
      if (!io || reduce || (window.Shopify && window.Shopify.designMode)) el.classList.add('in');
      else io.observe(el);
    });
  }

  /* Klaviyo client subscription. Public site ID + list ID only; never a private key. */
  function initForms(root) {
    root.querySelectorAll('form[data-hd48-klaviyo]:not([data-ready])').forEach(function (form) {
      form.setAttribute('data-ready', '');
      var box = form.closest('.signup');
      var msg = box.querySelector('.msg');
      var btn = form.querySelector('button');
      var label = btn.textContent;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.email.value.trim();
        var first = form.first_name.value.trim().split(' ')[0];
        msg.className = 'msg';
        if (!EMAIL_RE.test(email)) {
          msg.className = 'msg err';
          msg.textContent = form.dataset.errEmail;
          form.email.focus();
          return;
        }
        btn.disabled = true;
        btn.textContent = form.dataset.sending;
        var attrs = { email: email };
        if (first) attrs.first_name = first;
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: { custom_source: form.dataset.source, profile: { data: { type: 'profile', attributes: attrs } } },
              relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
            }
          })
        })
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            form.hidden = true;
            msg.className = 'msg ok';
            msg.innerHTML = form.dataset.success;
            (window.dataLayer = window.dataLayer || []).push({ event: 'generate_lead', form_id: form.id, form_type: 'guide_signup' });
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = label;
            msg.className = 'msg err';
            msg.innerHTML = form.dataset.errSend;
          });
      });
    });
  }

  /* Pick three */
  function initPick(root) {
    root.querySelectorAll('[data-hd48-pick]:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '');
      var max = +sec.dataset.max || 3;
      var opts = Array.prototype.slice.call(sec.querySelectorAll('.opt'));
      var count = sec.querySelector('[data-count]');
      var status = sec.querySelector('.pick-status');
      function picked() { return opts.filter(function (o) { return o.getAttribute('aria-pressed') === 'true'; }); }
      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          var on = o.getAttribute('aria-pressed') === 'true';
          if (!on && picked().length >= max) { status.textContent = sec.dataset.limit; return; }
          o.setAttribute('aria-pressed', String(!on));
          var names = picked().map(function (x) { return x.textContent.trim().toLowerCase(); });
          count.textContent = names.length;
          status.textContent = names.length === max
            ? sec.dataset.done.replace('[list]', names.join(', '))
            : names.length ? sec.dataset.more.replace('[n]', max - names.length) : '';
        });
      });
    });
  }


  /* Count-up counters: markup carries the final value, so no-JS visitors and search engines see real numbers */
  var cio = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); }
        });
      }, { threshold: 0.5 })
    : null;

  function fmt(n, commas) { return commas ? n.toLocaleString('en-US') : String(n); }

  function countUp(el) {
    var to = +el.dataset.to, commas = el.dataset.commas === 'true', t0 = null, dur = 1600;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      p = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(to * p), commas);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters(root) {
    root.querySelectorAll('.hd48 [data-to]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      if (!cio || reduce || (window.Shopify && window.Shopify.designMode)) return;
      el.textContent = '0';
      cio.observe(el);
    });
  }

  /* Growth Audit carousel: arrows, thumbnails, swipe */
  function initGallery(root) {
    root.querySelectorAll('.hd48 [data-hd48-carousel]:not([data-ready])').forEach(function (c) {
      c.setAttribute('data-ready', '');
      var slides = c.querySelectorAll('.pf-slide'), thumbs = c.querySelectorAll('.pf-thumb'), i = 0, x0 = null, moved = false;
      if (slides.length < 2) return;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', String(k === i)); });
      }
      c.querySelector('.pf-prev').addEventListener('click', function () { go(i - 1); });
      c.querySelector('.pf-next').addEventListener('click', function () { go(i + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.thumb); }); });
      var main = c.querySelector('.pf-main');
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; moved = false; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { moved = true; go(dx < 0 ? i + 1 : i - 1); }
      });
      /* A swipe should change the slide, not follow the product link */
      main.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } });
    });
  }

  /* Hero video: attach sources after page load so the photo is the first paint, fade in once playing */
  var saveData = navigator.connection && navigator.connection.saveData;
  function initVideo(root) {
    root.querySelectorAll('.hd48 video[data-hd48-video]:not([data-ready])').forEach(function (v) {
      v.setAttribute('data-ready', '');
      if (reduce || saveData) return;
      function start() {
        v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
        v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
        v.load();
        play();
      }
      function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      /* Browsers refuse autoplay in a background tab; try again when the visitor comes back */
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible' && v.paused && v.currentSrc) play();
      });
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once: true });
    });
  }

  /* Logo ticker: autoplay with requestAnimationFrame, pause on hover, drag or swipe to scroll */
  function initTicker(root) {
    root.querySelectorAll('.hd48 [data-hd48-ticker]:not([data-ready])').forEach(function (vp) {
      vp.setAttribute('data-ready', '');
      var track = vp.querySelector('.ticker-track');
      if (!track || reduce) return;
      track.classList.add('js-driven');
      var seconds = +vp.dataset.seconds || 35;
      var half = 0, pos = 0, last = 0, hover = false, drag = false, startX = 0, startPos = 0;
      function measure() { half = track.scrollWidth / 2; }
      function wrap() { if (half) { while (pos <= -half) pos += half; while (pos > 0) pos -= half; } }
      function frame(ts) {
        var dt = last ? Math.min((ts - last) / 1000, 0.1) : 0; /* no jump after a tab switch */
        last = ts;
        if (!hover && !drag && half) pos -= (half / seconds) * dt;
        wrap();
        track.style.transform = 'translateX(' + pos + 'px)';
        requestAnimationFrame(frame);
      }
      vp.addEventListener('mouseenter', function () { hover = true; });
      vp.addEventListener('mouseleave', function () { hover = false; });
      vp.addEventListener('pointerdown', function (e) {
        drag = true; startX = e.clientX; startPos = pos;
        vp.classList.add('is-dragging');
        vp.setPointerCapture(e.pointerId);
      });
      vp.addEventListener('pointermove', function (e) { if (drag) { pos = startPos + (e.clientX - startX); wrap(); } });
      function end() { drag = false; vp.classList.remove('is-dragging'); }
      vp.addEventListener('pointerup', end);
      vp.addEventListener('pointercancel', end);
      window.addEventListener('resize', measure);
      measure();
      track.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', measure, { once: true }); });
      requestAnimationFrame(frame);
    });
  }

  function init(root) { initReveal(root); initForms(root); initPick(root); initCounters(root); initGallery(root); initVideo(root); initTicker(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme editor re-renders a section in place; wire up the fresh markup */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
